import { themeTools } from "native-base";
const variants = {
    activated: (props) => {
        const colorToken = props.colorTheme ? `${props.colorTheme}.500` :  "primary.500";

        return {
            borderWidth: 0,
            transition: "0.3s all",
            
            bg: themeTools.transparentize(colorToken, .2)(props.theme),
            _hover: {
                bg: themeTools.transparentize(colorToken, .2)(props.theme)
            },
            _focus: {
                bg: themeTools.transparentize(colorToken, .2)(props.theme),
            },
            _focusVisible: {
                style: { boxShadow: "" },
                bg: themeTools.transparentize(colorToken, .3)(props.theme)
            },
            _pressed: {
                bg: themeTools.transparentize(colorToken, .3)(props.theme)
            }
        }
    },
    primary: (props) => {
        const colorToken = props.colorTheme ? `${props.colorTheme}.500` :  "primary.500";

        return {
            borderWidth: 0,
            transition: "0.3s all",
            
            bg: "transparent",
            _hover: {
                bg: themeTools.transparentize(colorToken, .2)(props.theme)
            },
            _focus: {
                bg: themeTools.transparentize(colorToken, .2)(props.theme),
            },
            _focusVisible: {
                style: { boxShadow: "" },
                bg: themeTools.transparentize(colorToken, .2)(props.theme)
            },
            _pressed: {
                bg: themeTools.transparentize(colorToken, .3)(props.theme)
            }
        }
    },
    muted: (props) => {
        const colorToken = "muted.500";

        return {
            borderWidth: 0,
            transition: "0.3s all",
            
            bg: "transparent",
            _hover: {
                bg: themeTools.transparentize(colorToken, .1)(props.theme)
            },
            _focus: {
                bg: themeTools.transparentize(colorToken, .1)(props.theme),
            },
            _focusVisible: {
                style: { boxShadow: "" },
                bg: themeTools.transparentize(colorToken, .1)(props.theme)
            },
            _pressed: {
                bg: themeTools.transparentize(colorToken, .15)(props.theme)
            }
        }
    }
}


export const PressableTheme = {
    Pressable: {
        baseStyle: {
            fontFamily: "body",
        },
        variants,
    }
}